import _ from 'lodash';
import { createContext, useContext, useReducer } from 'react';

const FilterContext = createContext(null);

const FilterDispatchContext = createContext(null);

export function FilterProvider({ children }) {
  const [selection, dispatch] = useReducer(filterReducer, initialSelection);

  return (
    <FilterContext.Provider value={selection}>
      <FilterDispatchContext.Provider value={dispatch}>{children}</FilterDispatchContext.Provider>
    </FilterContext.Provider>
  );
}

export function useFilter() {
  return useContext(FilterContext);
}

export function useFilterDispatch() {
  return useContext(FilterDispatchContext);
}

function filterReducer(state, action) {
  // console.log('selection-context.filterReducer(): state = %o, action = %o', state, action);
  let newState = _.cloneDeep(state);
  switch (action.type) {
    case 'phase-toggled': {
      newState.phaseIds = _.xor(newState.phaseIds, _.castArray(action.phaseId));
      break;
    }
    case 'phase-cleared': {
      newState.phaseIds = [];
      break;
    }
    case 'cause-toggled': {
      newState.causeIds = _.xor(newState.causeIds, _.castArray(action.causeId));
      break;
    }
    case 'cause-cleared': {
      newState.causeIds = [];
      break;
    }
    case 'role-toggled': {
      newState.roleIds = _.xor(newState.roleIds, _.castArray(action.roleId));
      break;
    }
    case 'role-cleared': {
      newState.roleIds = [];
      break;
    }
    case 'role-set': {
      newState.roleIds = _.castArray(action.roleId);
      break;
    }
    case 'activity-toggled': {
      newState.activityIds = _.xor(newState.activityIds, _.castArray(action.activityId));
      break;
    }
    case 'activity-cleared': {
      newState.activityIds = [];
      break;
    }
    case 'activity-set': {
      newState.activityIds = _.castArray(action.activityId);
      break;
    }
    case 'sortspec-set': {
      newState.sortSpec = action.sortSpec;
      break;
    }
    case 'search-set': {
      newState.search = action.search;
      break;
    }
    case 'charity-navigator-rating-set': {
      newState.stars = action.stars;
      break;
    }
    case 'cleared': {
      newState = initialSelection;
      break;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
  // console.log('filterReducer(): newState = %o', newState);
  return newState;
}

const initialSelection = {
  phaseIds: [],
  causeIds: [],
  roleIds: [],
  activityIds: [],
  sortSpec: [
    { id: 'charity_navigator_rating', label: 'Charity Navigator rating', direction: 'desc' },
    { id: 'revenue', label: 'Revenue', direction: 'desc' },
    { id: 'name', label: 'Organization name', direction: 'asc' },
  ],
  search: '',
  stars: 3,
};
